module.exports = __webpack_public_path__ + "static/media/off.8537ac93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/off.svg
// module id = 5944
// module chunks = 0